'use strict';

function applyNetworkOptions(target) {
  // NETWORK

  /** @prop {string} [network.ip] IP of the viewer/user. ie= '100.100.100.100'. */
  target['network.ip'] = undefined;

  /** @prop {string} [network.isp] Name of the internet service provider of the viewer/user. */
  target['network.isp'] = undefined;

  /**
   * @prop {string} [network.connectionType]
   * Type of connection used
   */
  target['network.connectionType'] = undefined;
}

module.exports = applyNetworkOptions;

